import React, { useState, useLayoutEffect, useContext } from 'react';
import * as S from './styles';
import InputSearchByCollection from 'components/InputSearchByCollection';
import SimpleInput from 'components/SimpleInput';
import Check from 'components/Buttons/Check';
import { formatDateToISO, formatToDateCustom } from 'utils/functions';
import DynamicPageContext from 'context/DynamicPage';
import { verifyIfFormCanSave } from './functions';
import { Product } from 'types/Product';
export interface DataFormProps {
	countdown: boolean;
	description: string;
	name: string;
	reference_id: string;
	schedule_end: string;
	schedule_start: string;
	products: Product[];
}

const initialData: DataFormProps = {
	countdown: false,
	description: '',
	name: '',
	reference_id: '',
	schedule_end: '',
	schedule_start: '',
	products: []
};

export default function InputsProductGrid() {
	const {
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		moduleOnPhoneToEdit,
		setModuleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [dataForm, setDataForm] = useState(initialData);

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
		}
	}, []);

	return (
		<S.container>
			<div>
				<InputSearchByCollection
					initialValue={dataForm.name}
					maxHeightList={100}
					getCollection={(value: { name: string; reference_id: string }) => {
						setDataForm((obj) => ({
							...obj,
							name: value.name,
							reference_id: value.reference_id
						}));
					}}
					setDataForm={setDataForm}
				/>
			</div>

			<div>
				<SimpleInput
					label="Descrição"
					initialValue={dataForm.description}
					getValue={(value: string) => {
						setDataForm((obj) => ({
							...obj,
							description: value
						}));
					}}
				/>

				<div style={{ display: 'none' }}>
					<S.inputsDate>
						<SimpleInput
							typeInput="datetime-local"
							label="Início"
							initialValue={
								dataForm.schedule_start === ''
									? ''
									: formatToDateCustom(dataForm.schedule_start)
							}
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									schedule_start: formatDateToISO(value)
								}));
							}}
							paddingInLineEnd
						/>

						<SimpleInput
							typeInput="datetime-local"
							label="Fim"
							initialValue={
								dataForm.schedule_end === ''
									? ''
									: formatToDateCustom(dataForm.schedule_end)
							}
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									schedule_end: formatDateToISO(value)
								}));
							}}
							paddingInLineEnd
						/>
					</S.inputsDate>

					<Check
						text="Contagem regressiva"
						isChecked={dataForm.countdown}
						setIsChecked={() => {
							setDataForm((obj) => ({
								...obj,
								countdown: !obj.countdown
							}));
						}}
					/>
				</div>
			</div>
		</S.container>
	);
}
